import i18n from 'i18next';

export const extractErrorMessageKeysFromHttpResponseException = (error: any): string[] => {
  if (error) {
    const response = error.response;

    const errorKeys: string[] = [];
    const appendError = (newError: string): void => {
      if (newError.indexOf(' ') === -1) {
        // if error is one-worded (e.g. ShortPassword), prepend "Errors_" to localize properly
        newError = 'Errors_' + newError;
      }

      errorKeys.push(newError);
    };

    if (response && response.data && response.data.errors) {
      const errors = response.data.errors;

      for (const key in errors) {
        if (!errors.hasOwnProperty(key)) {
          continue;
        }

        const value = errors[key];
        if (Array.isArray(value)) {
          value.forEach(v => appendError(v));
        } else {
          appendError(value);
        }
      }
      if (errorKeys.length === 0 && response.data.detail) {
        appendError(response.data.detail);
      }
      return errorKeys;
    } else {
      console.log(`Error : ${error}`);
      errorKeys.push(error.message);
    }
    return errorKeys;
  }

  return [];
};

const notUsableSubstring = '#$#$';
export const localizeErrors = (errorKeys: string[]): string => {
  const errors = errorKeys.map(key =>
    i18n.t(key as any, {
      nsSeparator: notUsableSubstring,
      keySeparator: notUsableSubstring,
    })
  );
  return errors.join('\n');
};
